// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"329":"7387a235","579":"97b7d55c","922":"88130a12","995":"893eb047"}[chunkId] + ".js";
};